import { Navigate, Route, Routes } from "react-router-dom";
import LogoOnlyLayout from "../components/layouts/ogoOnlyLayout";
import LoginForm from "../pages/users/LoginForm";
import ForGotPassword from "../pages/users/ForgotPassword";
import VerificationCode from "../pages/users/VerficationCode";
import ConfirmPassword from "../pages/users/ConfirmPassword";
import DashboardLayout from "../components/layouts/DashboardLayout";
import Dashboard from "../pages/users/dashboard/Dashboard";
import Advisors from "../pages/advisors/Advisor";
import AddOrUpdateAdvisor from "../pages/advisors/AddOrUpdateAdvisor";
import DefaultSetting from "../pages/settings/DefaultSetting";
import EditProfile from "../pages/profile/EditProfile";
import Cases from "../pages/cases/Cases";
import UpdateCases from "../pages/cases/UpdateCases";
import CaseDetail from "../pages/cases/CaseDetail";
import AttorneyCaseDetail from "../pages/advisors/AttorneycaseDetail";
import PoolsList from "../pages/pools/PoolsList";
import AttorneyPoolList from "../pages/pools/AtorneysPoolsList";

const Authentication = () => {
  if (localStorage.getItem("token")) {
    return <Navigate to="/dashboard"> </Navigate>;
  } else {
    return <Navigate to="/login"> </Navigate>;
  }
};

export default function ApRoutes() {
  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/default-settings" element={<DefaultSetting />} />
        <Route path="/list-advisors" element={<Advisors />} />
        <Route path="/list-pools" element={<PoolsList />} />
        <Route
          path="/list-pools/attorneys/:pool_id"
          element={<AttorneyPoolList />}
        />
        <Route
          path="/list-advisors/case-detail/:advisor_id"
          element={<AttorneyCaseDetail />}
        />
        <Route path="/profile-settings" element={<EditProfile />} />
        <Route path="/list-cases" element={<Cases />} />
        <Route path="/list-cases/detail/:id" element={<CaseDetail />} />
        <Route path="/list-cases/update/:user_id" element={<UpdateCases />} />
        <Route
          path="/list-advisors/add-advisor"
          element={<AddOrUpdateAdvisor />}
        />
        \{" "}
        <Route
          path="/list-advisors/update-advisor/:user_id"
          element={<AddOrUpdateAdvisor />}
        />
        <Route path="*" element={<Navigate to="/dashboard" />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Route>

      <Route element={<LogoOnlyLayout />}>
        <Route path="/" element={<Authentication />} />

        <Route path="/login" element={<LoginForm />} />
        <Route path="/forgot-password" element={<ForGotPassword />} />
        <Route path="/verification-code" element={<VerificationCode />} />
        <Route path="/confirm-password" element={<ConfirmPassword />} />
      </Route>
    </Routes>
  );
}
